/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  // Variável para controlar se a imagem já foi adicionada
  let imagemAdicionada = false;

  // Função para adicionar a imagem após o clique no botão
  function adicionarImagemAposClique() {
    if (imagemAdicionada) return; // Se a imagem já foi adicionada, sai da função

    const timerMsgElement = document.querySelector('.goodsc-cart__timer-msg');

    if (timerMsgElement) {
      const novaImagem = document.createElement('img');
      novaImagem.src = 'https://cdn.shopify.com/s/files/1/0873/2400/0550/t/2/assets/manequim.png'; // URL da imagem
      novaImagem.alt = 'Medidas'; // Texto alternativo
      novaImagem.width = 150; // Largura da imagem (opcional)
      novaImagem.classList.add('img-size');

      // Insere a imagem após o elemento .goodsc-cart__timer-msg
      timerMsgElement.insertAdjacentElement('afterend', novaImagem);

      // Marca que a imagem foi adicionada
      imagemAdicionada = true;
    } else {
      console.log('Elemento .goodsc-cart__timer-msg não encontrado após o clique.');
    }
  }

  // Configura o MutationObserver para observar mudanças no DOM
  const observer = new MutationObserver((mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        // Verifica se o botão .goodsc-link foi adicionado
        const botao = document.querySelector('.goodsc-link');

        if (botao) {
          // Adiciona o event listener ao botão
          botao.addEventListener('click', () => {
            // Aguarda um pouco antes de verificar o DOM (caso o .goodsc-cart__timer-msg seja adicionado após o clique)
            setTimeout(adicionarImagemAposClique, 500); // 500ms de delay
          });

          // Para de observar após encontrar o botão
          observer.disconnect();
        }
      }
    }
  });

  // Inicia a observação no corpo da página (ou em um container específico)
  observer.observe(document.body, { childList: true, subtree: true });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();